/**
 * Info product card (snippets/c-main-collection-card-v2.liquid).
 *
 * Touch devices have no hover, so each card shows an Info pill that opens and
 * closes its panel. A tap anywhere else closes the open panel and keeps its
 * normal effect (the card link still goes to the PDP).
 * Listens on the document so cards added by "Show more" work too.
 */
(() => {
  if (window.cMcCardV2Loaded) return;
  window.cMcCardV2Loaded = true;

  const OPEN_CLASS = 'is-info-open';
  const TOGGLE = '[data-c-mc-card-info-toggle]';

  const setOpen = (card, open) => {
    card.classList.toggle(OPEN_CLASS, open);
    const toggle = card.querySelector(TOGGLE);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  };

  const closeAll = (except) => {
    document.querySelectorAll(`.c-mc-card-v2.${OPEN_CLASS}`).forEach((card) => {
      if (card !== except) setOpen(card, false);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(TOGGLE);
    const card = toggle ? toggle.closest('.c-mc-card-v2') : null;
    if (!card) return closeAll();

    event.preventDefault();
    closeAll(card);
    setOpen(card, !card.classList.contains(OPEN_CLASS));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  // The back button restores the page as it was left; start with every panel closed.
  window.addEventListener('pageshow', () => closeAll());
})();
